module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-container sendi-admin-entry"
  }, [_c('div', {
    staticClass: "d-content"
  }, [_c('div', {
    staticClass: "login-header text-center"
  }, [_c('button', {
    staticClass: "return-login",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backPage
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/flecha.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Volver")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    class: _vm.tipologin,
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "id": "form-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "form-login"
    }
  }, [_c('router-view')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "title-login"
  }, [_c('img', {
    staticClass: "logo-login",
    attrs: {
      "src": "/static/img/sendi-logo.png",
      "width": "400",
      "height": "78",
      "alt": "Sendi"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c7c88ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1891
// module chunks = 1